
import Malla1 from "../assets/Mallas imagen/marron.jpg";
import Malla2 from "../assets/Mallas imagen/azul.jpg";
import Malla3 from "../assets/Mallas imagen/violeta.jpeg";
import Malla4 from "../assets/Mallas imagen/verde.PNG";
import { FaCreditCard } from "react-icons/fa";
import { useCarrito } from "../context/CarritoContext"; // ⬅️ NUEVO

import { Link } from "react-router-dom";
import fondoProductos from "../assets/Mallas imagen/mallaia.PNG"; 

export default function Productos() {
  // helpers IGUALES al Hero
  const formatPrice = (n) =>
    Number(n).toLocaleString("es-AR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  const precioTransfer = (n) => Math.round(n * 0.85);

  const precio30Off = (n) => Math.floor((n * 0.70) / 100) * 100;

  // ⬅️ NUEVO: funciones del carrito
  const { agregarAlCarrito, showAddBanner } = useCarrito();

  // Tu data
  const productos = [
    { id: "boardshort-1", nombre: "The Sunset", precio: 75200, img: Malla1 },
    { id: "boardshort-2", nombre: "The Ocean", precio: 75200, img: Malla2 },
    { id: "boardshort-3", nombre: "The Sundown", precio: 75200, img: Malla3 },
    { id: "boardshort-4", nombre: "The Tropic", precio: 75200, img: Malla4 },
  ];

  // ⬅️ NUEVO: handler comprar directo desde el listado
  const handleComprarListado = (e, producto) => {
    // Evita que navegue al detalle
    e.preventDefault();
    e.stopPropagation();

    const talle = "M";        // default desde listado
    const cantidad = 1;

    agregarAlCarrito(producto, talle);
    showAddBanner({ ...producto, talle, cantidad });
  };

  return (
    <div className="w-full">
      {/* Imagen única tipo Hero */}
      <section className="relative w-full h-[40vh] md:h-[90vh] overflow-hidden">
        <img
          src={fondoProductos}
          alt="Fondo productos"
          className="absolute inset-0 w-full h-full object-cover md:object-[40%_45%]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-black/10 to-transparent" />
        <div className="relative z-10 flex flex-col items-center justify-center text-white text-center h-full px-4">
          <h1 className="text-xl md:text-5xl title-onepalm mb-4 pt-14 drop-shadow-[0_1px_3px_rgba(0,0,0,0.8)]">
            Boardshorts
          </h1>
          <p className="block text-[11px] md:text-xs proba text-white/85 mb-1">
            92% poliéster 8% spandex
          </p>
        </div>
        <div id="nav-sentinel" className="absolute bottom-0 left-0 w-full h-px" />
      </section>

      {/* ===== TÍTULO INTERMEDIO ===== */}
      <div className="w-full bg-white">
        <div className="max-w-[1200px] mx-auto px-4 md:px-6 lg:px-6">
          <div className="pt-8 pb-2 md:pt-10 md:pb-0 text-center">
            <h2 className="title-onepalm text-md md:text-4xl text-gray-900">
              Collection Ss 26’
            </h2>
            <div className="mt-1 flex justify-center">
              <span className="inline-block h-[1px] w-24 bg-gray-900/90" />
            </div>
          </div>
        </div>
      </div>

      {/* Contenido debajo */}
      {/* === MISMO CONTENEDOR QUE HERO (solo desktop) === */}
      <div
        className="
          px-2 md:px-6 lg:px-8 2xl:px-12 py-0 mx-auto bg-white
          max-w-[1200px] lg:max-w-[1600px] xl:max-w-[1700px] 2xl:max-w-[1800px]
        "
      >
        {/* Lista de mallas */}
        {/* === 4 columnas y gap-8 como en Hero desktop === */}
        <div
          className="
            grid grid-cols-2 lg:grid-cols-4
            gap-y-6 md:gap-y-8
            gap-x-2 md:gap-x-6 lg:gap-x-8
            mt-8
          "
        >
          {productos.map((p) => {
            const precioOriginalFmt = formatPrice(p.precio);

            const precio30 = precio30Off(p.precio);
            const precio30Fmt = formatPrice(precio30);

            const transf = precioTransfer(precio30);
            const precioTransfFmt = formatPrice(transf);

            const cuotaFmt = formatPrice(precio30 / 3); // cuotas sobre el precio 30% OFF

            return (
              <Link
                key={p.id}
                to={`/producto/${p.id}`}
                aria-label={`Ir a ${p.nombre}`}
                className="bg-white group block w-full text-left sm:text-left pb-4"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              >
                {/* Imagen: igual que Hero desktop → aspect-[4/5] */}
                <div className="w-full overflow-hidden">
                  <div className="aspect-[3/5] lg:aspect-[4/5] overflow-hidden">
                    <img
                      src={p.img}
                      alt={p.nombre}
                      className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                      loading="lazy"
                    />
                  </div>
                </div>

                {/* NOMBRE (centrado como en Hero grid) */}
                <h3 className="nav-onepalm text-sm lg:text-lg text-gray-900 mt-3 text-left">
                  {p.nombre}
                </h3>

                {/* PRECIO BASE */}
                <div className="flex items-baseline gap-2 mt-1 text-left">
                  <span className="text-xs text-gray-500 line-through proba">
                    ${precioOriginalFmt}
                  </span>
                  <span className="text-xs font-semibold text-gray-900 proba">
                    ${precio30Fmt}
                  </span>
                  <span className="text-[10px] font-semibold text-red-600 proba">
                    30% OFF
                  </span>
                </div>

                {/* PRECIO TRANSFERENCIA */}
                <div className="text-xs mt-1 text-left">
                  <span className="inline-flex items-baseline gap-1 text-green-700 prueba whitespace-nowrap">
                    <span className="text-xs leading-none proba">
                       ${precioTransfFmt}
                    </span>
                    <span className="text-[8px] leading-none pd-onepalm">en Transferencia</span>
                  </span>
                </div>

                {/* 3 CUOTAS SIN INTERÉS */}
                <div className="text-[8px] text-black-900 mt-1 items-center text-left gap-1.5 prueba">
                  <span>3 cuotas sin interés de </span>
                  <span className="inline-flex proba items-center gap-1 font-semibold">
                    ${cuotaFmt} <FaCreditCard className="w-2 h-2" strokeWidth={1.75} aria-hidden="true" />
                  </span>
                </div>

                {/* ⬅️ NUEVO: Botón COMPRAR chico (no navega, agrega al carrito y muestra banner) */}
                <div className="mt-3 flex text-left">
                  <button
                    onClick={(e) => handleComprarListado(e, p)}
                    className="proba text-[9px] sm:w-auto border border-transparent
                     bg-gray-600 disabled:bg-gray-300 disabled:text-gray-500
                      disabled:cursor-not-allowed text-white px-4 py-1 shadow-sm
                      hover:bg-white hover:text-gray-700 hover:border-black active:scale-95 transition"
                    aria-label={`Comprar ${p.nombre}`}
                    title="Comprar"
                    type="button"
                  >
                    Comprar
                  </button>
                </div>
              </Link>
            );
          })}
        </div>
      </div>

      {/* Cartel estilo OnePalm — MISMO ANCHO QUE EL GRID (no full-bleed) */}
      <div className="hidden lg:block mx-auto w-full px-8 2xl:px-12 mt-16">
        <div
          className="
            mx-auto max-w-[1600px] xl:max-w-[1700px] 2xl:max-w-[1800px]
            bg-[#ffae00] text-gray-900 text-center py-12
          "
        >
          <h3 className="text-2xl xl:text-3xl nav-onepalm mb-3">
            Para quienes persiguen el verano
          </h3>
          <p className="max-w-5xl mx-auto pd-onepalm text-base xl:text-lg leading-relaxed">
            Donde hay amigos, hay verano. Y donde hay verano, el tiempo afloja y se estira. Vivimos la vida como se supone que debe vivirse…
            con una sonrisa en la cara, rodeados de buena gente y siempre yendo por más.
            Esto es <span className="font-semibold">WetSoul</span>.
          </p>
        </div>
      </div>

      {/* Versión mobile/tablet del cartel (sin cambios) */}
      <div className="block lg:hidden bg-[#ffae00] text-gray-900 py-8 px-6 text-center mt-16 max-w-[1200px] mx-auto">
        <h3 className="text-md md:text-3xl nav-onepalm mb-2">
          Para quienes persiguen el verano
        </h3>
        <p className="max-w-4xl mx-auto pd-onepalm md:text-lg leading-relaxed">
          Donde hay amigos, hay verano. Y donde hay verano, el tiempo afloja y se estira. Vivimos la vida como se supone que debe vivirse…
          con una sonrisa en la cara, rodeados de buena gente y siempre yendo por más.
          <p>~<span className="font-semibold"> WetSoul </span> ~</p>
        </p>
      </div>
    </div>
  );
}